import { render } from "./CanceledOrderSuccess.vue?vue&type=template&id=5021b500"
import script from "./CanceledOrderSuccess.vue?vue&type=script&lang=js"
export * from "./CanceledOrderSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__